import React from 'react';
import JobProgress from './JobProgress';
import { formatRelativeTime } from './time';
import { VARIANTS_WITH_LOGS } from './types';
import type { QueueJob, QueueSectionVariant } from './types';

interface JobRowProps {
  job: QueueJob;
  variant: QueueSectionVariant;
  onViewLogs: (job: QueueJob) => void;
}

/** One job as a table row. Which cells render is driven by the section variant. */
export default function JobRow({ job, variant, onViewLogs }: JobRowProps) {
  // The processor can report a job before its title is known.
  const title = job.file_title || `File #${job.file_id}`;

  return (
    <tr>
      <td>
        <a href={`/player?id=${job.file_id}`} target="_blank">{title}</a>
      </td>
      <td>{job.job_id}</td>
      <td>{fileTypeNameForId(job.file_type_id)}</td>
      <td>{job.queueName}</td>

      {variant === 'running' && (
        <td>
          <JobProgress progressPercent={job.progress_percent} mode={job.mode} fps={job.fps} />
        </td>
      )}

      {variant === 'failed' && (
        <td className="server-queues__error">
          {job.last_error || '\u2014'}
          {job.failures > 0 && (
            <span className="server-queues__failures">
              {' '}
              ({job.failures} {job.failures === 1 ? 'failure' : 'failures'})
            </span>
          )}
        </td>
      )}

      {(variant === 'failed' || variant === 'successful') && (
        <td>{formatRelativeTime(job.finished_seconds_ago)}</td>
      )}

      {VARIANTS_WITH_LOGS.includes(variant) && (
        <td>
          {/* A button, not an anchor: it doesn't navigate, and an <a> without
              an href isn't keyboard-operable. Styled to read as a link. */}
          <button
            type="button"
            className="server-queues__logs-link"
            onClick={() => onViewLogs(job)}
          >
            View Logs
          </button>
        </td>
      )}
    </tr>
  );
}

function fileTypeNameForId(file_type_id: number): string {
    switch (file_type_id) {
        case 1:
            return "Video";

        case 2:
            return "Audio";

        case 3:
            return "Image";

        case 6:
            return "Document";

        default:
            return "Unknown";
    }
}
